import API from '..'

export const AccountAPI = {
  apiRateStatus: () => {
    return API.get('/fanfou/api_rate')
  },
}
